export default (function () { return ({
    height: '100%',
    width: '100%',
    defaultColumnCount: 5,
    gridGap: undefined,
    padding: undefined,
}); });
